import { am } from './utils';

import httpClient from '@/utils/httpClient';

export const GET_KNOWLEDGE_FILES = am('GET_KNOWLEDGE_FILES');
export const GET_KNOWLEDGE_HISTORY = am('GET_KNOWLEDGE_HISTORY');

const baseUrl = inventionId => `/api/v2/nlp/knowledge/${encodeURIComponent(inventionId)}`;

export const state = {
  files: [],
  history: [],
  isLoadingFiles: false,
  isLoadingHistory: false,
  loadingHistoryFailed: false
};

export const actions = {
  async loadFiles({ commit }, inventionId) {
    try {
      commit(GET_KNOWLEDGE_FILES.STARTED);
      const files = await httpClient.get(baseUrl(inventionId));
      commit(GET_KNOWLEDGE_FILES.COMPLETED, files);
      return files;
    } catch (e) {
      commit(GET_KNOWLEDGE_FILES.FAILED);
      throw e;
    }
  },
  async loadFile(context, { inventionId, path }) {
    return httpClient.get(`${baseUrl(inventionId)}/file?path=${encodeURIComponent(path)}`);
  },
  async saveFile(context, { inventionId, path, content, message, baseVersion }) {
    return httpClient.put(`${baseUrl(inventionId)}/file`, { path, content, message, baseVersion });
  },
  async deleteFile(context, { inventionId, path }) {
    await httpClient.delete(`${baseUrl(inventionId)}/file?path=${encodeURIComponent(path)}`);
  },
  async loadHistory({ commit }, { inventionId, path }) {
    try {
      commit(GET_KNOWLEDGE_HISTORY.STARTED);
      const history = await httpClient.get(`${baseUrl(inventionId)}/file/history?path=${encodeURIComponent(path)}`);
      commit(GET_KNOWLEDGE_HISTORY.COMPLETED, history);
      return history;
    } catch (e) {
      commit(GET_KNOWLEDGE_HISTORY.FAILED);
      throw e;
    }
  },
  async activateVersion(context, { inventionId, path, version }) {
    return httpClient.post(`${baseUrl(inventionId)}/file/activate`, { path, version });
  },
  async deleteVersion(context, { inventionId, path, version }) {
    await httpClient.delete(`${baseUrl(inventionId)}/file/version/${version}?path=${encodeURIComponent(path)}`);
  }
};

export const mutations = {
  [GET_KNOWLEDGE_FILES.STARTED](state) {
    state.isLoadingFiles = true;
  },
  [GET_KNOWLEDGE_FILES.COMPLETED](state, files) {
    state.isLoadingFiles = false;
    state.files = files;
  },
  [GET_KNOWLEDGE_FILES.FAILED](state) {
    state.isLoadingFiles = false;
  },
  [GET_KNOWLEDGE_HISTORY.STARTED](state) {
    state.isLoadingHistory = true;
    state.loadingHistoryFailed = false;
    state.history = [];
  },
  [GET_KNOWLEDGE_HISTORY.COMPLETED](state, history) {
    state.isLoadingHistory = false;
    state.history = history;
  },
  [GET_KNOWLEDGE_HISTORY.FAILED](state) {
    state.isLoadingHistory = false;
    state.loadingHistoryFailed = true;
  }
};

export default {
  namespaced: true,
  state,

  mutations,
  actions
};
